import type {
  useJSTBroadcast,
  JSTBroadcastSubscription,
} from "@indeed/tare/broadcast/JSTBroadcast";
import { BroadcastEventName } from "@indeed/tare/broadcast/JSTBroadcast.types";

import { resetJobInteractionsForLogout } from "./jobInteractionsState";

/** Subscribe one RN provider root to logout cleanup and return an immediate teardown function. */
export function subscribeToJobInteractionsLogout(
  broadcast: ReturnType<typeof useJSTBroadcast>,
): () => void {
  let active = true;
  let subscription: JSTBroadcastSubscription | null = null;

  void broadcast
    .subscribe(BroadcastEventName.UserDidLogout, resetJobInteractionsForLogout)
    .then((nextSubscription) => {
      if (!active) {
        void nextSubscription?.remove();
        return;
      }
      subscription = nextSubscription;
    });

  return () => {
    active = false;
    void subscription?.remove();
  };
}
